import { updateObject } from "../Utility";
import {
  GUIDE_CATEGORIES_GET_START,
  GUIDE_CATEGORIES_GET_SUCCESS,
  GUIDE_CATEGORIES_GET_FAIL,
} from "../actions/GuideCategoriesActions";

const initialState = {
  items: {},
  loading: false,
  fetched: false,
  error: null,
};

// GET:
const getGuideCategoriesStart = (state, actions) => {
  return updateObject(state, {
    loading: true,
    error: null,
  });
};

const getGuideCategoriesSuccess = (state, action) => {
  return updateObject(state, {
    ...state,
    items: action.guideCategories.reduce((obj, item) => {
      obj[item.id] = item;
      return obj;
    }, {}),
    loading: false,
    fetched: true,
    error: null,
  });
};

const getGuideCategoriesFail = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: action.error,
  });
};

const GuideCategoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    // GET:
    case GUIDE_CATEGORIES_GET_START:
      return getGuideCategoriesStart(state, action);
    case GUIDE_CATEGORIES_GET_SUCCESS:
      return getGuideCategoriesSuccess(state, action);
    case GUIDE_CATEGORIES_GET_FAIL:
      return getGuideCategoriesFail(state, action);

    default:
      return state;
  }
};

export default GuideCategoriesReducer;
